var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIsometricPull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 231,
    viewBox: "0 0 110 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1581_15455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1389 135.59C52.1389 135.59 59.3708 134.888 60.6338 134.747C61.8969 134.607 68.3341 132.806 69.5041 132.897C70.6741 132.989 75.6377 135.801 75.894 136.646C76.1503 137.489 74.8323 142.182 74.8323 142.182L73.9064 142.104C73.9064 142.104 73.5296 142.834 73.0156 142.787C72.5 142.739 69.7863 140.818 68.897 140.724C68.0076 140.631 66.3877 141.154 64.5068 141.314C62.6245 141.474 59.7232 140.912 59.7232 140.912L52.8894 141.71C52.8894 141.71 50.5494 138.569 50.4548 138.195C50.3602 137.816 52.1389 135.59 52.1389 135.59Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9902 137.254C69.1779 137.254 71.8458 138.378 72.7809 139.269C73.7175 140.159 73.9066 142.101 73.9066 142.101L74.8325 142.179C74.8325 142.179 75.2154 139.033 74.3261 138.05C73.4368 137.066 70.7216 136.55 70.3936 136.55C70.0656 136.551 68.9902 137.254 68.9902 137.254Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.687 210.228C61.4765 210.329 57.6844 210.68 57.6844 210.68C57.6844 210.68 52.4888 216.937 52.98 217.993C53.4712 219.047 57.8949 221.627 61.1943 221.638C64.4938 221.648 78.6068 218.695 78.8875 215.532C79.1682 212.368 76.7107 213.141 73.4113 211.594C70.1118 210.046 65.0566 207.656 64.776 207.586C64.4953 207.515 61.687 210.228 61.687 210.228Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2994 198.587C59.2994 198.587 59.2293 205.056 58.4574 207.868C57.6855 210.68 57.6855 210.68 57.6855 210.68C57.6855 210.68 60.564 213.493 61.8987 213.563C63.2334 213.633 65.9014 211.805 66.182 211.243C66.4627 210.68 67.7303 199.674 67.1583 198.779C66.5863 197.884 65.7595 196.619 64.7772 196.266C63.7933 195.915 59.2994 198.587 59.2994 198.587Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.497 222.638C67.4955 223.013 69.1536 228.365 69.1536 228.365L75.2552 224.927L75.4719 181.335L69.7592 181.681L66.9769 185.853L66.7969 222.166L67.497 222.638Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4961 197.721V227.345L69.2706 228.376V198.095L64.4961 197.721Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3516 206.251L34.8199 209.251L69.2696 198.095V191.064C69.2696 191.064 48.0192 190.314 46.9895 191.064C45.9599 191.814 34.8199 196.876 34.8199 196.876L34.3516 206.251Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4143 145.316C99.4143 145.316 101.193 147.754 100.444 152.348C99.6949 156.941 97.1673 159.472 93.8908 159.565C90.6142 159.659 86.2149 158.346 82.1894 157.034C78.1638 155.722 73.2963 155.534 68.5218 155.534C63.7473 155.534 55.5101 154.503 55.5101 154.503C55.5101 154.503 51.3915 152.441 51.2038 151.879C51.0162 151.317 51.4845 144.379 52.1404 144.285C52.7964 144.192 58.8812 143.442 59.7232 143.442C60.5653 143.442 98.7599 144.192 98.7599 144.192L99.4143 145.316Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.998 197.72V208.407L34.8199 209.25V196.876L29.998 197.72Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.998 178.973C29.998 178.973 20.9646 182.913 19.7 184.738C18.437 186.564 19.7 194.861 19.7 195.704C19.7 196.548 36.5512 200.626 40.2015 200.486C43.8518 200.345 69.268 191.064 69.268 191.064V177.255L29.998 178.973Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9722 189.011C39.8629 189.078 60.7121 184.414 69.2696 182.47V177.255L29.9981 178.973C29.9981 178.973 20.9646 182.913 19.7001 184.738C19.5994 184.883 19.5155 185.068 19.4453 185.287C25.2891 186.742 34.5285 188.954 36.9722 189.011Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9491 216.164C91.7386 216.375 88.7411 217.241 88.7411 217.241C88.7411 217.241 83.6646 225.797 84.0154 227.413C84.3663 229.031 89.8425 230.998 93.4241 230.998C97.0058 230.998 97.7075 229.734 103.184 230.015C108.66 230.296 110.416 224.46 109.924 222.702C109.433 220.944 104.799 221.155 102.973 221.085C101.147 221.014 95.5307 217.24 95.5307 217.24L91.9491 216.164Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4194 157.983C96.4194 157.983 98.9394 159.19 100.628 161.816C102.317 164.44 101.287 173.064 101.287 173.064C101.287 173.064 101.943 179.147 99.6014 190.731C97.2614 202.314 97.2614 219.75 97.2614 219.75C97.2614 219.75 95.3898 221.812 94.1725 221.624C92.9552 221.436 88.4614 218.531 88.4614 218.531C88.4614 218.531 89.3034 203.063 88.4614 199.594C87.6194 196.124 85.6531 190.781 86.2145 179.906C86.7758 169.032 89.1158 162.095 89.1158 162.095L96.4194 157.983Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1956 166.597C98.1956 166.597 96.5588 169.886 91.8301 170.535",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9602 162.285C23.9602 162.285 22.0885 166.446 22.7902 173.341C23.4919 180.236 28.6874 182.772 35.7089 184.738C42.7303 186.704 57.333 185.725 66.6014 184.738C75.8697 183.751 83.03 184.15 83.03 184.15C83.03 184.15 84.5752 184.897 88.7869 177.996C93 171.096 95.5276 166.033 95.9486 163.643C96.3697 161.252 93.8421 155.012 93.8421 155.012C93.8421 155.012 83.872 155.241 80.2217 155.012C76.5714 154.783 60.9833 154.396 60.1413 154.309C59.2993 154.221 53.9634 154.309 53.9634 154.309C53.9634 154.309 45.9596 152.991 40.0624 154.309C34.1652 155.628 23.9602 162.285 23.9602 162.285Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8391 29.2817L47.7148 27.6656L56.7727 11.947H59.0196L65.829 28.7196L64.5584 28.6463L58.3179 12.9705H57.1937L49.1899 27.6656L48.8391 29.2817Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7148 27.6658V31.2509L65.829 32.4226V28.7198L47.7148 27.6658Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1312 109.226C13.6629 108.754 7.85874 106.787 7.85874 106.787C7.85874 106.787 5.51876 109.225 4.95742 111.287C4.39607 113.349 4.48912 113.818 4.48912 113.818C4.48912 113.818 1.3056 120.662 4.48912 129.567C4.48912 129.567 10.2002 127.291 10.4809 124.351C10.7616 121.412 14.1312 109.226 14.1312 109.226Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16 104.068C14.5041 103.88 10.5731 103.599 10.5731 103.599L7.8579 106.787C7.8579 106.787 8.9806 114.568 7.29655 120.661C5.61098 126.755 4.48828 129.567 4.48828 129.567C4.48828 129.567 7.2035 135.661 9.35585 138.473C11.5097 141.285 13.6621 145.504 17.2193 149.254C20.7766 153.004 22.9304 155.629 23.4918 158.255C24.0531 160.879 23.9601 162.286 23.9601 162.286C23.9601 162.286 27.6104 166.505 36.8787 165.379C46.1471 164.255 48.0188 160.974 51.0147 158.348C54.0106 155.723 55.5085 154.504 55.5085 154.504C55.5085 154.504 53.3546 136.227 53.4492 134.585C53.5423 132.943 53.4492 124.352 53.4492 124.352C53.4492 124.352 54.4789 119.349 52.9809 114.944C51.483 110.538 49.4237 106.6 49.4237 106.6L34.5021 100.226L29.6712 101.229L18.3237 101.726L15.16 104.068Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8721 93.2297C11.8721 93.2297 12.6089 97.7864 11.8721 100.412C11.1354 103.037 10.574 103.6 10.574 103.6C10.574 103.6 13.7575 105.1 15.3485 106.975C16.9395 108.849 17.9295 109.13 18.3231 109.225C18.7182 109.318 20.1215 106.787 22.1824 105.006C24.2416 103.224 29.6721 101.228 29.6721 101.228C29.6721 101.228 29.0558 97.0256 28.8026 93.5153C28.5494 90.005 22.7452 84.3805 21.528 84.1926C20.3107 84.0048 13.5242 82.1213 12.8454 82.7354C12.1665 83.3494 9.45133 81.7562 10.1073 86.1617C10.7616 90.5687 11.8721 93.2297 11.8721 93.2297Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8685 100.979C30.8685 100.979 30.0448 106.506 32.5724 114.943C35.1 123.379 43.9 122.629 46.8013 120.193C49.7027 117.755 50.0367 107.835 50.0367 107.835C50.0367 107.835 55.2262 100.975 57.7538 98.2555C60.2814 95.5365 62.9966 90.662 63.3703 85.6929C63.744 80.7238 68.2379 72.1939 68.2379 67.0369C68.2379 61.8798 65.9909 50.5377 64.493 45.3822C62.995 40.2267 62.4337 36.8508 62.4337 36.8508L55.0385 39.1941C55.0385 39.1941 56.0682 44.6307 55.4123 52.131C54.7563 59.6313 55.5053 69.0059 55.5053 69.0059C55.5053 69.0059 50.9184 73.6924 48.7645 77.8183C46.6107 81.9427 45.7686 86.1619 45.7686 86.1619C45.7686 86.1619 38.5611 88.8809 35.3776 92.5364C32.1971 96.1933 30.8685 100.979 30.8685 100.979Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5801 85.0377C54.462 82.5616 54.1036 90.6637 54.1036 90.6637",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0409 39.1955C55.0409 39.1955 51.9276 37.0859 50.8049 36.1022C49.6822 35.1184 49.1895 33.9926 49.1895 32.9386C49.1895 31.8846 49.49 31.3912 49.49 31.3912C49.49 31.3912 50.1718 31.3912 50.3823 30.8291C50.5928 30.2669 49.6806 27.1034 50.1718 26.2586C50.663 25.4154 52.5591 25.2749 52.8397 25.2749C53.1204 25.2749 55.8585 24.4317 56.5602 24.5722C57.2619 24.7127 58.1054 25.2749 58.1054 25.2749C58.1054 25.2749 59.0176 24.783 59.791 25.0641C60.5629 25.3451 60.8435 26.2586 60.8435 26.2586C60.8435 26.2586 62.2484 26.0478 63.0203 26.8208C63.7922 27.5937 62.5474 37.4632 62.5474 37.4632C62.5474 37.4632 59.5103 39.9684 59.1595 40.2495C58.8087 40.5321 55.0409 39.1955 55.0409 39.1955Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.469 145.316L98.8131 144.192C98.8131 144.192 60.6185 143.442 59.7764 143.442C59.3066 143.442 57.2031 143.676 55.3223 143.899V154.382C55.4748 154.46 55.5648 154.505 55.5648 154.505C55.5648 154.505 63.8035 155.536 68.5765 155.536C73.351 155.536 78.2186 155.724 82.2441 157.036C86.2697 158.348 90.6689 159.66 93.9455 159.567C97.2221 159.474 99.7497 156.943 100.499 152.349C101.248 147.754 99.469 145.316 99.469 145.316Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4032 145.298C97.6749 145.701 95.5576 146.395 93.7973 147.472C90.6153 149.419 92.4412 156.631 97.3042 158.377C98.8601 157.196 99.9859 155.16 100.443 152.348C101.192 147.754 99.4138 145.316 99.4138 145.316L99.4032 145.298Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7202 140.911L54.1738 143.379V144.806L54.4103 144.867L91.2686 147.944C91.2686 147.944 92.9405 146.216 93.2211 146.123C93.5018 146.03 98.7568 144.194 98.7568 144.194L59.7202 140.911Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0581 12.0723L58.8735 0H56.7715V12.0723H59.0581Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54083 81.049C0.987105 79.9064 0.648465 78.8783 0.463891 77.9572C0.138979 76.8772 0.00474377 75.921 0.00169296 75.0854C-0.00288325 74.8548 0.00169296 74.6195 0.016947 74.3843C0.169488 72.1647 1.36998 70.2553 1.36998 70.2553C1.69947 68.0098 3.22792 66.8275 3.22792 66.8275C3.22792 66.8275 3.22792 66.8275 3.8869 65.3854C4.54587 63.9434 6.60517 63.0483 6.60517 63.0483C6.60517 63.0483 6.87364 62.5671 8.13058 61.8125C9.38751 61.0594 11.1112 60.9968 11.1112 60.9968C11.1112 60.9968 11.5536 60.1276 13.5153 59.5303C15.4769 58.933 16.9642 59.5074 16.9642 59.5074C16.9642 59.5074 16.9642 59.5074 16.9688 59.5074C17.9084 59.4432 18.7718 59.4845 19.5177 59.6372H19.5193C21.3574 59.7304 22.2863 60.6515 22.7775 61.177C23.1024 61.3145 23.6561 61.6063 24.1229 62.1409C24.1519 62.1608 24.1839 62.1791 24.216 62.2005C24.8414 62.5992 24.9634 63.502 24.9604 64.1542C24.9756 64.3467 24.9649 64.5529 24.9283 64.7714C24.9192 64.9134 24.9024 65.0601 24.878 65.2113C24.8795 65.2541 24.8841 65.2953 24.8917 65.335L24.8475 65.4679C24.8429 65.5657 24.849 65.6589 24.8688 65.7459L24.4341 67.2903C24.4341 67.2903 23.7324 80.1279 23.7278 80.5281C23.7233 80.9283 16.3373 83.545 16.3373 83.545C16.3373 83.545 15.9117 88.4424 15.2908 90.2372C14.6715 92.0321 11.8724 93.2267 11.8724 93.2267C11.8724 93.2267 4.68774 87.5396 1.54083 81.049Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8626 65.312C24.8626 65.312 28.1834 68.6558 28.7981 69.5006C29.4144 70.3453 30.1237 73.4279 30.3769 73.8541C30.6301 74.2803 35.246 77.8257 35.3024 78.1435C35.3589 78.4612 33.6184 79.5656 33.6199 79.7535C33.623 79.9429 34.1874 81.7577 34.3048 81.9074C34.4238 82.0571 34.526 82.442 34.526 82.442C34.526 82.442 34.9745 83.1096 34.979 83.5342C34.9836 83.9589 35.1972 84.6111 35.249 84.8739C35.3009 85.1366 36.448 87.7625 36.2848 88.2865C36.1231 88.8089 30.8071 91.4378 29.84 91.5737C28.8728 91.7097 21.8911 89.2244 21.049 88.4743C20.207 87.7243 18.9608 84.9014 18.9608 84.9014C18.9608 84.9014 16.4591 85.4482 14.7751 83.9482C13.091 82.4466 11.9668 79.005 13.6585 77.6944C15.3501 76.3837 17.3027 78.5315 17.8121 79.1181C18.3201 79.7031 19.0386 80.4302 19.1621 80.4547C19.2857 80.4791 19.6167 77.9877 19.5618 76.758C19.5069 75.5283 17.234 73.2477 17.0418 71.9615C16.8496 70.6753 17.8457 68.7811 18.4482 68.2251C19.0569 67.6706 24.8626 65.312 24.8626 65.312Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2437 90.3475C31.5266 90.2466 33.1892 89.8541 34.4431 89.5165C32.7606 90.4269 29.4062 93.4316 28.8007 93.5171C27.8335 93.6531 22.2018 90.3337 21.0531 88.4777C20.4597 87.5184 18.9648 84.9048 18.9648 84.9048C18.9648 84.9048 20.8609 87.1915 22.0919 88.102C23.3214 89.0124 27.8763 90.5338 30.2437 90.3475Z",
    fill: "white",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1581_15455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 231,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIsometricPull);
export default __webpack_public_path__ + "static/media/ic-isometric-pull.8f78b95d1b3ef1fc04e310a831055577.svg";
export { ForwardRef as ReactComponent };